export function PublicConfig (pConfig)
{
  return (
  {
    name : 'EditorToolbarPublicConfig'
  });
}